export default __webpack_public_path__ + "static/media/huddle.e315c017.png";